import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { AvailabilityPane } from 'components/AvailabilityCalendarPane';
import { HotelCardContext } from 'components/HotelCardContext';
import { getHotelAvailabilityPrices, getHotelAvailabilityPricesComplete, getSearchParameters } from 'modules/sapiSearch/selectors';
import { getDatesToDisplay, MAX_DATES_TO_SHOW_DESKTOP } from '@daedalus/core/src/_web/availability';
import { Loading } from './Loading';
interface Props {
  sourceComponentPrefix: string;
}
const AvailabilityPaneWrapper = /*#__PURE__*/styled('div')({
  name: "AvailabilityPaneWrapper",
  class: "a16b54cq",
  propsAsIs: false
});
export const UnavailabilityDesktop = ({
  sourceComponentPrefix
}: Props) => {
  const {
    hotelId
  } = useContext(HotelCardContext);
  const {
    checkIn
  } = useSelector(getSearchParameters);
  const hotelAvailabilityPrices = useSelector(state => getHotelAvailabilityPrices(state, hotelId));
  const datesToDisplay = hotelAvailabilityPrices && getDatesToDisplay(hotelAvailabilityPrices, checkIn, MAX_DATES_TO_SHOW_DESKTOP);
  const availabilitySearchComplete = useSelector(getHotelAvailabilityPricesComplete);
  const [initialSearchComplete, setInitialSearchComplete] = useState<boolean>(false);
  useEffect(() => {
    if (availabilitySearchComplete) {
      // Preserve initial search complete state to avoid showing the `loading` state when more data is being fetched
      setInitialSearchComplete(true);
    }
  }, [availabilitySearchComplete]);
  return initialSearchComplete ? datesToDisplay && <AvailabilityPaneWrapper>
        <AvailabilityPane hotelId={hotelId} sourceComponentPrefix={sourceComponentPrefix} hotelAvailabilityPrices={hotelAvailabilityPrices} datesToDisplay={datesToDisplay} availabilitySearchComplete={availabilitySearchComplete} />
      </AvailabilityPaneWrapper> : <AvailabilityPaneWrapper>
      <Loading />
    </AvailabilityPaneWrapper>;
};

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");